import { inheritsLoose as _inheritsLoose, extends as _extends, asyncToGenerator as _asyncToGenerator } from './_virtual/_rollupPluginBabelHelpers.js';
import { createContext, createElement, useContext, Fragment, Component } from 'react';
import _regeneratorRuntime from 'regenerator-runtime';
import { isJS } from './utils.esm.js';
import serialize from 'serialize-javascript';

var __AfterContext = /*#__PURE__*/createContext({});
var Document = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Document, _React$Component);

  function Document() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Document.prototype;

  _proto.render = function render() {
    var helmet = this.props.helmet; // get attributes from React Helmet

    var htmlAttrs = helmet.htmlAttributes.toComponent();
    var bodyAttrs = helmet.bodyAttributes.toComponent();
    return createElement("html", Object.assign({}, htmlAttrs), createElement("head", null, createElement("meta", {
      httpEquiv: "X-UA-Compatible",
      content: "IE=edge"
    }), createElement("meta", {
      charSet: "utf-8"
    }), createElement("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1"
    }), helmet.title.toComponent(), helmet.meta.toComponent(), helmet.link.toComponent(), createElement(AfterStyles, null)), createElement("body", Object.assign({}, bodyAttrs), createElement(AfterRoot, null), createElement(AfterData, null), createElement(AfterScripts, null)));
  };

  return Document;
}(Component);

Document.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var renderPage, page;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            renderPage = _ref.renderPage;
            _context.next = 3;
            return renderPage();

          case 3:
            page = _context.sent;
            return _context.abrupt("return", _extends({}, page));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useAfterContext = function useAfterContext() {
  return useContext(__AfterContext);
};
var AfterRoot = function AfterRoot() {
  var _useAfterContext = useAfterContext(),
      html = _useAfterContext.html;

  return createElement("div", {
    id: "root",
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
var AfterData = function AfterData(_ref3) {
  var data = _ref3.data;

  var _useAfterContext2 = useAfterContext(),
      contextData = _useAfterContext2.data;

  return createElement("script", {
    defer: true,
    dangerouslySetInnerHTML: {
      __html: "window.__SERVER_APP_STATE__ =  " + serialize(_extends({}, data || contextData))
    }
  });
};
var AfterStyles = function AfterStyles() {
  var _useAfterContext3 = useAfterContext(),
      assets = _useAfterContext3.assets,
      styles = _useAfterContext3.styles;

  return createElement(Fragment, null, assets.client.css && createElement("link", {
    rel: "stylesheet",
    href: assets.client.css
  }), styles.map(function (path) {
    return createElement("link", {
      key: path,
      rel: "stylesheet",
      href: path
    });
  }));
};
var AfterScripts = function AfterScripts() {
  var _useAfterContext4 = useAfterContext(),
      scripts = _useAfterContext4.scripts,
      assets = _useAfterContext4.assets;

  return createElement(Fragment, null, scripts.filter(isJS).map(function (path) {
    return createElement("script", {
      key: path,
      defer: true,
      type: "text/javascript",
      src: path,
      crossOrigin: "anonymous"
    });
  }), assets.client.js && createElement("script", {
    type: "text/javascript",
    src: assets.client.js,
    defer: true,
    crossOrigin: "anonymous"
  }));
};

export { AfterData, AfterRoot, AfterScripts, AfterStyles, Document, __AfterContext, useAfterContext };
//# sourceMappingURL=Document.esm.js.map
